/** Available page size options for paginated lists */
export const PAGE_SIZE_OPTIONS = [
  10, 25, 50, 100, 250, 500,
] as const;

/** Type for page size values */
export type PageSize = (typeof PAGE_SIZE_OPTIONS)[number];

/** Default page size */
export const DEFAULT_PAGE_SIZE: PageSize = 25;

/** Validates and returns a valid page size, or the default */
export function getValidPageSize(value: unknown): PageSize {
  const num = Number(value);
  const match = PAGE_SIZE_OPTIONS.find((s) => s === num);
  return match ?? DEFAULT_PAGE_SIZE;
}
